<template>
    <div class="complainant_info">
        <el-form
            :model="ruleForm"
            :rules="rules"
            class="ruleForm"
            label-width="250px"
            ref="ruleForm"
        >
            <el-form-item label="投诉编号：" prop="complaintNumber" class="single-row">
                <span>{{ ruleForm&&ruleForm.complaintCode }}</span>
            </el-form-item>
            <el-form-item label="投诉提交时间：" prop="objectionTime" class="double-row">
                <span>{{ ruleForm&&ruleForm.submitTime }}</span>
            </el-form-item>
            <!-- <el-form-item label="提交状态：" prop="submitStatus" class="double-row">
        <span>{{ ruleForm.complaintAppellees&&ruleForm.complaintAppellees.submitStatus }}</span>
            </el-form-item>-->
            <el-form-item label="被投诉人信息：" prop="complainedAgainst" class="single-row">
                <el-table
                    :data="ruleForm.complaintAppellees"
                    stripe
                    border
                    style="width: 100%"
                    :header-cell-style="this.$globalGrayTableHeaderStyle"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        header-align="center"
                        align="center"
                        width="50"
                    ></el-table-column>
                    <el-table-column
                        align="left"
                        header-align="center"
                        label="主体类别"
                        min-width="60"
                        prop="mainTypeName"
                    >
                        <!-- <template slot-scope="scope">
              <input type="text" v-model="scope.row.subjectCategory" v-show="scope.row.isEditor"/>
              <span v-show="!scope.row.isEditor">{{ scope.row.subjectCategory }}</span>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                        prop="entName"
                        label="主体名称"
                        min-width="130"
                        :show-overflow-tooltip="true"
                        header-align="center"
                        align="left"
                    >
                        <!-- <template slot-scope="scope">
              <input type="text" v-model="scope.row.subjectName" v-show="scope.row.isEditor"/>
              <span v-show="!scope.row.isEditor">{{ scope.row.subjectName }}</span>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        header-align="center"
                        label="主体代码"
                        min-width="100"
                        prop="entCode"
                    >
                        <!-- <template slot-scope="scope">
              <input type="text" v-model="scope.row.subjectCode" v-show="scope.row.isEditor"/>
              <span v-show="!scope.row.isEditor">{{ scope.row.subjectCode }}</span>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                        prop="legalAgentor"
                        label="法定代表人"
                        min-width="80"
                        header-align="center"
                        :show-overflow-tooltip="true"
                        align="center"
                    >
                        <!-- <template slot-scope="scope">
              <input type="text" v-model="scope.row.legalRepresentative" v-show="scope.row.isEditor"/>
              <span v-show="!scope.row.isEditor">{{ scope.row.legalRepresentative }}</span>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="地址"
                        header-align="center"
                        min-width="140"
                        :show-overflow-tooltip="true"
                        align="left"
                    >
                        <!-- <template slot-scope="scope">
              <input type="text" v-model="scope.row.address" v-show="scope.row.isEditor"/>
              <span v-show="!scope.row.isEditor">{{ scope.row.address }}</span>
                        </template>-->
                    </el-table-column>
                    <el-table-column label="操作" width="120" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                title="查看"
                                @click="handleChastened(scope.row)"
                            >发起联合惩戒</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>

            <el-form-item label="投诉内容和请求：" prop="complaintsRequests" class="single-row">
                <el-input v-model="ruleForm.content" disabled type="textarea" cols="30" rows="10"></el-input>
            </el-form-item>
            <el-form-item label="投诉依据与理由：" prop="complaintGrounds" class="single-row">
                <!--        <span class="wrap">{{ ruleForm.complaintGrounds }}</span>-->
                <el-input v-model="ruleForm.reason" disabled type="textarea" cols="30" rows="10"></el-input>
            </el-form-item>
          
            <el-col :span="24" v-for="(item,index) in ruleForm.attachments" :key="index">
                <affix-doc
                  :item.sync="item"
                  :name="item.fileTypeName"
                  class="affixDown"
                  labelWidth="250px"
                />
<!--                <el-form-item :label="item[0].fileTypeName+'：'">-->
<!--                    <span v-for="(element,ind) in item" :key="ind">-->
<!--                        <span style="margin-right:20px">{{element.name}}</span>-->
<!--                        <em-->
<!--                            v-show="element.filePath"-->
<!--                            style="margin-right:5px"-->
<!--                            class="el-icon-view"-->
<!--                            @click="fileView(element,index,ind)"-->
<!--                        ></em>-->
<!--                        <em-->
<!--                            v-show="element.filePath"-->
<!--                            class="el-icon-download"-->
<!--                            style="margin-right:20px"-->
<!--                            @click="fileDownload(element,index,ind)"-->
<!--                        ></em>-->

<!--                        <el-dialog-->
<!--                            :visible.sync="imgDialogVisible"-->
<!--                            width="740px"-->
<!--                            height="100%"-->
<!--                            @closed="dialogClose"-->
<!--                        >-->
<!--                            <img style="width:100%; object-fit: fill;" :src="filePath" alt @contextmenu.prevent class="viewImg" />-->
<!--                        </el-dialog>-->
<!--                        <el-dialog-->
<!--                            :visible.sync="pdfDialogVisible"-->
<!--                            @closed="dialogClose"-->
<!--                            height="100%"-->
<!--                            top="8vh"-->
<!--                            width="80%"-->
<!--                        >-->
<!--                            <iframe-->
<!--                                :src="'/pdf/web/viewer.html?file=' + filePath + '?range=true' "-->
<!--                                @contextmenu.prevent-->
<!--                                frameborder="0"-->
<!--                                height="600"-->
<!--                                width="100%"-->
<!--                            ></iframe>-->
<!--                        </el-dialog>-->
<!--                    </span>-->
<!--                </el-form-item>-->
            </el-col>
        </el-form>
    </div>
</template>
<script>
import affixDoc from "@/components/affixDoc";
export default {
    props: ["ruleForm"],
    data() {
        return {
            baseURL:'',
            filePath: "",
            imgDialogVisible: false,
            pdfDialogVisible: false,
            limitNum: 1, // 上传excell时，同时允许上传的最大数
            fileList: [], // excel文件列表

            // ruleForm: {
            //   complaintNumber: JSON.parse(sessionStorage.getItem("oneliner")).complaintNumber,
            //   objectionTime: JSON.parse(sessionStorage.getItem("oneliner")).objectionTime,
            //   complaintsRequests: '黄石市军转站战备设施建设项目一期外立面玻璃幕墙工程第一中标候选人河南颍淮建工有限公司不具备中标资格，投标提供虚假材料。\n' +
            //       '第二中标候选人河南霖磐建设工程有限公司投标提供虚假材料。\n' +
            //       '招标人组织的评标委员对投诉人废标原因未明确、未履行问题澄清程序，招标文件中的评标办法设置不合理。\n' +
            //       '\n',
            //   complaintGrounds: '(一)质疑河南颍淮建工有限公司拟派项目经理业绩的真实性。经网上查询的襄城县中医院整体项目搬迁项目一玻璃幕墙、石材幕墙、网架工程、抗震支架工程中标项目经理为他人，聊城市茌平区人民医院老院区功能提升一老病房楼幕墙改造项目中标公司和项目经理均为他人。\n' +
            //       '(二)河南颍淮建工有限公司2019年9月17日在通辽市招投标过程中的串通投标行为被通辽市住建局记不良行为一次，同时禁止在2019年10月31日至2021年10月30日内承接当地任何工程项目，质疑河南颍淮建工有限公司在本次招标中不具有投标资格。\n' +
            //       '(三)经网上查询，河南颍淮建工有限公司近三年有三十多起诉讼案件，未按招标文件第86页“(五)近年来发生的诉讼和仲裁情况”(近年为近3年)如实填报，涉嫌提供虚假的信用状况。\n' +
            //       '(四)质疑河南霖磐建设工程有限公司业绩的真实性。经投诉人现场查询,项城市德银购物广场外立面玻璃幕墙工程不存在，另有多项新疆项目，网上查询无果。\n' +
            //       '(五)质疑投标文件不符合清标要求而废标，没有明确具体原因，期间也并未履行问题澄清程序。投诉人投标文件报价使用的广联达软件，软件会将分析表中的主要材料价格自动生成到主要材料价格表中,不解哪一项不符合要求。(五)质疑招标文件中的评分办法设置不合理，不严谨。一个1500万的幕墙项目，业绩的设置形同虚设，既没有金额限制，也没有网上公示之类的要求，存在为特定企业降低门槛及量身定做的重大嫌疑。',
            //   complainedAgainst: "",
            //   submitStatus: '已提交'
            // },
            options: [],
            rules: {
                complaintsRequests: [
                    {
                        required: true,
                        message: "请输入投诉内容和请求",
                        trigger: "blur"
                    }
                ],
                complaintGrounds: [
                    {
                        required: true,
                        message: "请输入投诉依据与理由",
                        trigger: "blur"
                    }
                ],
                complainedAgainst: [
                    {
                        required: true,
                        message: "请选择被投诉人类别",
                        trigger: "change"
                    }
                ]
            },
            tableData: [
                {
                    date: "2016-05-02",
                    subjectCategory: "投标人",
                    subjectName: "河南颍淮建工有限公司",
                    subjectCode: "91330108694830971X",
                    legalRepresentative: "万辉",
                    address: "河南林州市原康镇西院",
                    isEditor: false
                },
                {
                    date: "2016-05-04",
                    subjectCategory: "投标人",
                    subjectName: "河南霖磐建设工程有限公司",
                    subjectCode: "91410581080831997C",
                    legalRepresentative: "刘晓亚",
                    address: "河南林州市原康镇政府院内二楼",
                    isEditor: false
                },
                {
                    date: "2016-05-01",
                    subjectCategory: "投标人",
                    subjectName: "黄石市养老产业投资发展有限责任公司",
                    subjectCode: "91411100356188868C",
                    legalRepresentative: "吴书坤",
                    address: "黄石市郾城区嫩江路与王前路南300米路东",
                    isEditor: false
                }
            ]
        };
    },
    components: {
        affixDoc
    },
    mounted() {this.baseURL = baseURL;},
    methods: {
        handleChastened() {},
        isAssetTypeAnImage(ext) {
            let arr = [
                "png",
                "jpg",
                "jpeg",
                "bmp",
                "gif",
                "webp",
                "psd",
                "svg",
                "tif",
                "tiff"
            ];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnPDF(ext) {
            let arr = ["pdf", "PDF"];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },

        fileDownload(item,firstI,secondJ) {

            console.log(item,this.ruleForm.attachments[firstI][secondJ].filePath);
            if (item.filePath) {
                this.$httpReq({
                    method: "get",
                    url: `/attachment/downloadFileByKey?attachmentId=${item.id}`
                    // responseType:'blob'
                }).then(res => {
                    if (res.data.code === "1") {
                        console.log(res.data.data,"res.data.data");
                        var a = document.createElement("a");
                        a.download = item.name || "ceshi下載";
                        a.target = "_Blank";
                        a.href =res.data.data;
                        $("body").append(a);
                        a.click();
                        $(a).remove();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.data.msg
                        });
                    }
                });
                
                      
            }
                     
        },
        fileView(item,i,j) {
            // // 获取文件类型
            // debugger;
            let type = item.name.substr(item.name.lastIndexOf(".") + 1);
            let imgFlag = this.isAssetTypeAnImage(type);

            let pdfFlag =this.isAssetTypeAnPDF(type);

            if (pdfFlag) {
                this.imgDialogVisible = false;
                this.pdfDialogVisible = true;
                this.filePath=this.ruleForm.attachments[i][j].filePath
                return;
            }
            if (imgFlag) {
                // this.$httpReq({
                //     method: "POST",
                //     url: `/attachment/getAttachmentByCiteIdAndFileType?bizid=${item.bizId}&fileType=${item.fileType}`
                // }).then(res => {
                //     if (res.data.code == "1") {
                //         this.filePath = res.data.data.filePath;
                //         this.imgDialogVisible = true;
                //         this.pdfDialogVisible = false;
                //     }
                // });
                this.imgDialogVisible = true;
                this.pdfDialogVisible = false;
                this.filePath=this.ruleForm.attachments[i][j].filePath
            } else {
                fileDownload(item);
            }
        },
        dialogClose() {
            this.imgDialogVisible = false;
            this.pdfDialogVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.complainant_info {
    .ruleForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .el-dialog__wrapper /deep/ .el-dialog__header {
    }

    .el-dialog__wrapper /deep/ .el-dialog__body {
        padding: 10px 20px;
    }

    .el-form /deep/ .el-form-item.single-row {
        width: 100%;
        margin-bottom: 20px;
        .wrap {
            word-break: normal;
            width: auto;
            display: block;
            white-space: pre-wrap;
            word-wrap: break-word;
            overflow: hidden;
        }
    }

    .el-form /deep/ .el-form-item.double-row {
        width: 50%;
        margin-bottom: 20px;
    }
    em:hover{
        cursor: pointer;
        color: #1890ff;
    }
}
</style>
